/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';

const isArguments = function(value: any): boolean {
  return isType(value, 'Arguments');
};

export default isArguments;
